angular.module('nv.routes.error-pages').config(errorPagesConfigBlock);

function errorPagesConfigBlock($urlRouterProvider, $stateProvider) {
  // handle missing routes
  $urlRouterProvider.otherwise(function($injector, $location) {
    // make this smarter and more extensible
    // current angular routes pattern for shelter:
    // /network/shelter/...
    // /shelter-picker
    // /shelter/...
    if ($location.$$url.includes('/shelter')) return;
    else return '/not-found?missingUrl=' + encodeURIComponent($location.url());
  });

  $stateProvider.state('not-found', {
    url: '/not-found?missingUrl',
    controller: 'NotFoundCtrl',
    controllerAs: 'notFound',
    template: require('../../features/not-found/not-found.html'),
  });
}
